import { render, staticRenderFns } from "./SpotTable.vue?vue&type=template&id=10eb2244&scoped=true"
import script from "./SpotTable.vue?vue&type=script&lang=js"
export * from "./SpotTable.vue?vue&type=script&lang=js"
import style0 from "./SpotTable.vue?vue&type=style&index=0&id=10eb2244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10eb2244",
  null
  
)

export default component.exports